import Image from "next/image";
import {CSSProperties} from "react";

export type StaticTageaImageProps = {
    src: any,
    alt: string,
    responsive?: boolean,
    fitHeight?: boolean,
    width?: number,
    height?: number,
    preload?: boolean,
    fitParent?: boolean,
    style?: CSSProperties
}

export const StaticTageaImage = ({src, alt, responsive, width, height, preload = false, style, fitHeight, fitParent}: StaticTageaImageProps) => {
    const styles:CSSProperties = {
        ...style
    }
    if (responsive) {
        styles.width = "100%"
        styles.height = "auto"
    } else if (fitHeight) {
        styles.width = "auto"
        styles.height = "100%"
    } else if (fitParent) {
        styles.width = "100%"
        styles.height = "100%"
    }
    return <Image style={styles} src={src} alt={alt} width={width} height={height} priority={preload}/>
}
